import React from 'react'

interface IProps {
	searchQuery: string
	onSearchChange: (searchValue: string) => void
}

const ATeamSearch: React.FC<IProps> = ({ searchQuery, onSearchChange }) => {
	return (
		<div className='relative'>
			<input
				type='text'
				placeholder='Hľadať členov tímu...'
				value={searchQuery}
				onChange={e => onSearchChange(e.target.value)}
				className='w-full md:w-64 py-3.5 border-b border-[#483577] !focus:outline-none '
			/>
		</div>
	)
}

export default ATeamSearch
